// extracted by mini-css-extract-plugin
export default {"root":"loadingpage_root__+n3U3"};